export default "__VITE_ASSET__HjTPmwVl__"